import { getCurrentInstance as x, shallowRef as F, ref as _, watch as g, unref as c, onMounted as w } from "vue";
import { useEventListener as u } from "./index562.js";
import { isElement as C } from "./index565.js";
import { isFocusable as k } from "./index566.js";
import { isFunction as E } from "./index575.js";
function y(a, {
  disabled: r,
  beforeFocus: f,
  afterFocus: m,
  beforeBlur: v,
  afterBlur: d
} = {}) {
  const h = x(), { emit: p } = h, n = F(), o = _(!1), s = (e) => {
    const t = E(f) ? f(e) : !1;
    c(r) || o.value || t || (o.value = !0, p("focus", e), m?.());
  }, i = (e) => {
    var t;
    const l = E(v) ? v(e) : !1;
    c(r) || e.relatedTarget && ((t = n.value) != null && t.contains(e.relatedTarget)) || l || (o.value = !1, p("blur", e), d?.());
  }, b = (e) => {
    var t, l;
    c(r) || k(e.target) || (t = n.value) != null && t.contains(document.activeElement) && n.value !== document.activeElement || (l = a.value) == null || l.focus();
  };
  return g([n, () => c(r)], ([e, t]) => {
    e && (t ? e.removeAttribute("tabindex") : e.setAttribute("tabindex", "-1"));
  }), u(n, "focus", s, !0), u(n, "blur", i, !0), u(n, "click", b, !0), process.env.NODE_ENV === "test" && w(() => {
    const e = C(a.value) ? a.value : document.querySelector("input,textarea");
    e && (u(e, "focus", s, !0), u(e, "blur", i, !0));
  }), {
    isFocused: o,
    /** Avoid using wrapperRef and handleFocus/handleBlur together */
    wrapperRef: n,
    handleFocus: s,
    handleBlur: i
  };
}
export {
  y as useFocusController
};
